module.exports = __webpack_public_path__ + "605ae7db1f0bc22ceacfacfd3b0c9e43.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/onboarding/quotes.png
// module id = 543
// module chunks = 0